<template>
  <ProductDrawerNew v-if="showSpecifications" heading="Specifications">
    <div>
      <h2 class="productSpecifications__productTitleText">
        Specifications for {{ getProductTitle || getEnhancedProductTitle }}
      </h2>
      <div class="productSpecifications__secondaryDivider" />
      <div
        v-for="(specObj, index) in getSpecification"
        :key="index"
        class="productSpecifications__Specparent"
      >
        <div class="productSpecifications__SpecifictionTitleDisplay">
          {{ specObj.Title }}
        </div>
        <div class="productSpecifications__allDetails">
          <div
            class="productSpecifications__specDetailWrapper"
            v-for="(detail, index) in specObj.SpecificationsDetails"
            :key="index"
          >
            <div class="productSpecifications__SpecifictionDisplay">
              <span v-html="detail.AttibuteText"></span>
              <tool-tip class="tooltip-not-mobile" v-if="detail.MoreInfo">
                <span v-html="detail.MoreInfo"></span>
              </tool-tip>
            </div>
            <div class="productSpecifications__listContainer">
              <ul
                v-if="detail.AttibuteValue.length > 1"
                class="productSpecifications__SpecifictionList"
              >
                <li
                  v-for="(val, index) in detail.AttibuteValue"
                  :key="index"
                  v-html="val"
                ></li>
              </ul>
              <span
                v-else-if="detail.AttibuteValue[0]"
                class="productSpecifications__SpecifictionList"
                v-html="detail.AttibuteValue[0]"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ProductDrawerNew>
</template>

<script>
import { mapGetters } from "vuex";
import ToolTip from "../shared/ToolTip.vue";
import ProductDrawerNew from "../product/ProductDrawerNew.vue";

export default {
  components: {
    ToolTip,
    ProductDrawerNew
  },
  computed: {
    ...mapGetters("product", ["getProduct", "getProductTitle"]),
    ...mapGetters("enhancedproduct", ["getEnhancedProductTitle"]),
    ...mapGetters("prodspecification", ["getSpecification"]),
    showSpecifications() {
      return this.getSpecification && this.getSpecification.length > 0;
    }
  },
  props: {
    heading: String
  }
};
</script>

<style lang="scss" scoped>
.productSpecifications {
  &__wraper {
    @include media-breakpoint-between(xs, md) {
      margin-bottom: 45px;
    }
    @include media-breakpoint-up(md) {
      margin-bottom: 60px;
    }
  }
  &__wrapper {
    margin-bottom: 60px;
  }
  &__fullWidthDivider {
    display: block;
    height: 1px;
    background: $lightgray;
    border-radius: 0px;
    width: 100%; /* vw fallback for ie*/
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }

  &__specTitle {
    display: block;
    color: $gray-darker;
    letter-spacing: $letter-spacing-sm;
    font-family: $body;
    font-size: 18px;
    text-align: left;
    margin-bottom: 24px;
    margin-top: 24px;
    @include media-breakpoint-up(md) {
      font-size: 20px;
      margin-bottom: 27px;
      margin-top: 21px;
    }
    @include media-breakpoint-up(lg) {
      font-family: $body;
      font-size: 24px;
      margin-bottom: 43px;
      margin-top: 19px;
      letter-spacing: $letter-spacing-md;
    }
  }

  &__titleSpan {
    @include media-breakpoint-up(lg) {
      border-bottom: 3px solid $secondary-300;
    }
  }

  &__secondaryDivider {
    height: 3px;
    background: $secondary-300;
    border-radius: 0px;
  }

  &__productTitleText {
    display: block;
    color: $black-66;
    letter-spacing: 0.2px;
    line-height: 24px;
    font-family: $body;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    margin-bottom: 10px;
    @include media-breakpoint-up(md) {
      font-size: 16px;
      margin-bottom: 11px;
    }
    @include media-breakpoint-up(lg) {
      font-size: 20px;
    }
  }

  &__Specparent {
    border-bottom: 3px solid $secondary-300;
    margin-bottom: 30px;
    @include media-breakpoint-up(lg) {
      padding-top: 20px;
      display: flex;
    }
  }

  &__SpecifictionDisplay {
    font-family: $body;
    color: $black-66;
    font-size: 16px;
    letter-spacing: 0px;
    line-height: 30px;
    width: 50%;
    text-align: left;
    @include media-breakpoint-up(lg) {
      font-size: 20px;
    }
  }

  &__allDetails {
    @include media-breakpoint-up(lg) {
      flex-grow: 1;
    }
  }

  &__specDetailWrapper {
    display: flex;
    border-bottom: 1px solid $gray-light;
    padding-bottom: 8px;
    padding-top: 12px;
    line-height: 1.4em;
    &:last-of-type {
      border-bottom: none;
      margin-bottom: none;
    }
    @include media-breakpoint-up(lg) {
      &:first-of-type {
        padding-top: 0px;
      }
    }
  }

  &__SpecifictionTitleDisplay {
    font-family: $heading;
    color: $black85;
    font-size: 20px;
    letter-spacing: $letter-spacing-xs;
    text-align: left;
    border-bottom: 1px solid $gray-light;
    padding-bottom: 8px;
    font-weight: bold;
    line-height: 39px;
    @include media-breakpoint-up(md) {
      padding-bottom: 8px;
      font-size: 20px;
    }
    @include media-breakpoint-up(lg) {
      border-bottom: none;
      font-size: 26px;
      width: 33.33%;
    }
  }

  &__listContainer {
    width: 50%;
    text-align: left;
    font-family: $body;
    color: $black-66;
    font-size: 16px;
    letter-spacing: 0px;
    padding-left: 14px;
    li {
      list-style-type: square;
      margin-left: 1em;
    }
    li::marker {
      font-size: 12px;
    }

    @include media-breakpoint-up(lg) {
      font-size: 20px;
    }
  }

  &__SpecifictionList {
    margin-bottom: 0;
  }
}
</style>
